export default "__VITE_PUBLIC_ASSET__cc83cb67__"